var map = {
	"./Account/Show": 7038,
	"./Account/Show.vue": 7038,
	"./Auth/Login": 7154,
	"./Auth/Login.vue": 7154,
	"./Brands/Create": 3313,
	"./Brands/Create.vue": 3313,
	"./Brands/Edit": 3418,
	"./Brands/Edit.vue": 3418,
	"./Brands/Index": 7260,
	"./Brands/Index.vue": 7260,
	"./Clients/Payments/Create": 559,
	"./Clients/Payments/Create.vue": 559,
	"./Contacts/Create": 4640,
	"./Contacts/Create.vue": 4640,
	"./Contacts/Edit": 2437,
	"./Contacts/Edit.vue": 2437,
	"./Contacts/Index": 1214,
	"./Contacts/Index.vue": 1214,
	"./Contacts/Show": 9151,
	"./Contacts/Show.vue": 9151,
	"./Dashboard/Index": 2652,
	"./Dashboard/Index.vue": 2652,
	"./Dealers/Edit": 4793,
	"./Dealers/Edit.vue": 4793,
	"./Dealers/Index": 798,
	"./Dealers/Index.vue": 798,
	"./Deposits/Create": 3444,
	"./Deposits/Create.vue": 3444,
	"./Deposits/Edit": 2279,
	"./Deposits/Edit.vue": 2279,
	"./Deposits/Index": 9408,
	"./Deposits/Index.vue": 9408,
	"./Deposits/Products": 2534,
	"./Deposits/Products.vue": 2534,
	"./Deposits/Transfer": 6478,
	"./Deposits/Transfer.vue": 6478,
	"./Deposits/TransferCreate": 2765,
	"./Deposits/TransferCreate.vue": 2765,
	"./Devolutions/Create": 9463,
	"./Devolutions/Create.vue": 9463,
	"./Devolutions/Index": 4216,
	"./Devolutions/Index.vue": 4216,
	"./Devolutions/Show": 3409,
	"./Devolutions/Show.vue": 3409,
	"./Groups/Create": 4621,
	"./Groups/Create.vue": 4621,
	"./Groups/Edit": 4689,
	"./Groups/Edit.vue": 4689,
	"./Groups/Index": 494,
	"./Groups/Index.vue": 494,
	"./Information": 8242,
	"./Information.vue": 8242,
	"./Inventories/Create": 5054,
	"./Inventories/Create.vue": 5054,
	"./Inventories/Index": 5256,
	"./Inventories/Index.vue": 5256,
	"./Inventories/Show": 434,
	"./Inventories/Show.vue": 434,
	"./LogSystem/Index": 6310,
	"./LogSystem/Index.vue": 6310,
	"./Orders/Create": 859,
	"./Orders/Create.vue": 859,
	"./Orders/CreateClient": 2877,
	"./Orders/CreateClient.vue": 2877,
	"./Orders/Index": 5170,
	"./Orders/Index.vue": 5170,
	"./Orders/Pos": 7867,
	"./Orders/Pos.vue": 7867,
	"./Orders/PosShow": 8125,
	"./Orders/PosShow.vue": 8125,
	"./Orders/Show": 2419,
	"./Orders/Show.vue": 2419,
	"./Organizations/Create": 8185,
	"./Organizations/Create.vue": 8185,
	"./Organizations/Edit": 1408,
	"./Organizations/Edit.vue": 1408,
	"./Organizations/Index": 1547,
	"./Organizations/Index.vue": 1547,
	"./ProductCategories/Create": 6890,
	"./ProductCategories/Create.vue": 6890,
	"./ProductCategories/Edit": 2997,
	"./ProductCategories/Edit.vue": 2997,
	"./ProductCategories/Index": 7448,
	"./ProductCategories/Index.vue": 7448,
	"./Products/Create": 6039,
	"./Products/Create.vue": 6039,
	"./Products/Edit": 5153,
	"./Products/Edit.vue": 5153,
	"./Products/Index": 1199,
	"./Products/Index.vue": 1199,
	"./Providers/Create": 6815,
	"./Providers/Create.vue": 6815,
	"./Providers/Edit": 1550,
	"./Providers/Edit.vue": 1550,
	"./Providers/Index": 9330,
	"./Providers/Index.vue": 9330,
	"./Providers/Show": 5022,
	"./Providers/Show.vue": 5022,
	"./Reports/Index": 3671,
	"./Reports/Index.vue": 3671,
	"./Request": 57,
	"./Request.vue": 57,
	"./Requests/Edit": 5159,
	"./Requests/Edit.vue": 5159,
	"./Requests/Index": 6086,
	"./Requests/Index.vue": 6086,
	"./Shopping/Create": 9418,
	"./Shopping/Create.vue": 9418,
	"./Shopping/Edit": 7854,
	"./Shopping/Edit.vue": 7854,
	"./Shopping/Index": 1052,
	"./Shopping/Index.vue": 1052,
	"./Shopping/Show": 2779,
	"./Shopping/Show.vue": 2779,
	"./Spents/Create": 6431,
	"./Spents/Create.vue": 6431,
	"./Spents/Edit": 7076,
	"./Spents/Edit.vue": 7076,
	"./Spents/Index": 5320,
	"./Spents/Index.vue": 5320,
	"./SuccessApply": 1491,
	"./SuccessApply.vue": 1491,
	"./Taxes/Create": 5936,
	"./Taxes/Create.vue": 5936,
	"./Taxes/Edit": 6487,
	"./Taxes/Edit.vue": 6487,
	"./Taxes/Index": 5578,
	"./Taxes/Index.vue": 5578,
	"./Users/Create": 7218,
	"./Users/Create.vue": 7218,
	"./Users/Edit": 9663,
	"./Users/Edit.vue": 9663,
	"./Users/Index": 1294,
	"./Users/Index.vue": 1294,
	"./Version/Index": 8053,
	"./Version/Index.vue": 8053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8846;